<!-- 学校-学生托管统计 -->
<template>
<div>
    <div class="index" v-show="!detail.show">
        <div class="title">
            <div class="span1">
                <span>{{$route.name}}</span>
            </div>
        </div>

      <header>
        <div class="header-item">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>学生托管统计</span>
          </div>
          <div id="echarts-box1"></div>
        </div>

        <div class="header-item">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>近七天学生出勤变化</span>
          </div>
          <div id="echarts-box2"></div>
        </div>
      </header>

        <div>
            <el-form :inline="true" :model="queryParams" label-width="70px">
                <el-form-item label="">
                    <el-select v-model="queryParams.semester" clearable placeholder="选择学年学期" class="label">
                        <el-option v-for="item in semesterList" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
				<el-form-item label="">
                    <el-select v-model="queryParams.campus" clearable placeholder="选择校区" class="label">
                        <el-option v-for="item in campusList" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="">
                    <el-select v-model="queryParams.grade" clearable placeholder="选择年级" class="label">
                        <el-option v-for="item in gradeList" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="">
                    <el-select v-model="queryParams.class" clearable placeholder="选择班级" class="label">
                        <el-option v-for="item in classList" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="" style="margin-left:20px">
                    <el-button type="primary" size="small" @click='searchFun()'>搜索</el-button>
                </el-form-item>
            </el-form>

            <div class="table">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="className" label="班级名称" align="center">
                    </el-table-column>
                    <el-table-column prop="headTeacherName" label="班主任" align="center">
                    </el-table-column>
                    <el-table-column prop="signNum" label="学生人数" align="center">
                    </el-table-column>
                    <el-table-column prop="classStudentNum" label="托管报名人数" align="center">
                    </el-table-column>
					<el-table-column prop="pj" label="生均报名数" align="center">
                    </el-table-column>
                    <el-table-column prop="signRate" label="托管报名率" align="center">
                    </el-table-column>
                    <el-table-column header-align="center" align="center" label="操作" width="200" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="toDetail(scope.row)">查看详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination background :current-page="pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage" layout="total,prev, pager, next,jumper,sizes" @size-change="sizeChangeHandle" @current-change="currentChangeHandle"></el-pagination>
                </div>
            </div>
        </div>
    </div>
    <Detail :info.sync="detail.info" v-show="detail.show" @to-index="toIndex"></Detail>
</div>
</template>
<script>
import api from '@/api/wisdomSchool/index.js'
import * as echarts from "echarts";
export default {
    components:{
        Detail: ()=>import('./detail.vue')
    },
	data() {
		return {
			pageNum: 1,
			pageSize: 10,
			totalPage: 0,
			queryParams: {
				semester: '',
				campus:'',
				grade: '',
				class: '',
			},
			campusList:	[
				// {id:'campus1',label:'驻马店实验小学主校区'},
			],	// 校区列表
			gradeList: [
				{id:'g1',label:'一年级'},
				{id:'g2',label:'二年级'},
				{id:'g3',label:'三年级'},
				{id:'g4',label:'四年级'},
				{id:'g5',label:'五年级'},
				{id:'g6',label:'六年级'},
			],	// 年级列表
			classList: [
				{id:'bj1',label:'1班'},
				{id:'bj2',label:'2班'},
				{id:'bj3',label:'3班'},
				{id:'bj4',label:'4班'},
				{id:'bj5',label:'5班'},
				{id:'bj6',label:'6班'},
			],	// 班级列表
			semesterList: [
				{id:'xq1',label:'2021~2022年度下学期'},
				{id:'xq2',label:'2021~2022年度上学期'},
				{id:'xq3',label:'2020~2021年度下学期'},
				{id:'xq4',label:'2020~2021年度上学期'},
				{id:'xq5',label:'2019~2020年度下学期'},
				{id:'xq6',label:'2019~2020年度上学期'},
			],
			tableData: [
				{className:'一年级1班',headTeacherName:'戴先中',signNum:'59',classStudentNum:'38',pj:'1.1',signRate:'64.41%'},
				{className:'一年级2班',headTeacherName:'魏海坤',signNum:'59',classStudentNum:'48',pj:'1.1',signRate:'79.59%'},
				{className:'一年级3班',headTeacherName:'陈夕松',signNum:'59',classStudentNum:'28',pj:'1.1',signRate:'74.41%'},
				{className:'一年级5班',headTeacherName:'张凯锋',signNum:'59',classStudentNum:'28',pj:'1.1',signRate:'54.41%'},
				{className:'二年级1班',headTeacherName:'谈英姿',signNum:'59',classStudentNum:'38',pj:'1.1',signRate:'54.41%'},
				{className:'二年级2班',headTeacherName:'马旭东',signNum:'59',classStudentNum:'28',pj:'1.1',signRate:'74.41%'},
				{className:'二年级3班',headTeacherName:'付影杰',signNum:'59',classStudentNum:'38',pj:'1.1',signRate:'64.41%'},
			],
            detail:{
                info:{},
                show:false,
            },
			school_info:JSON.parse(sessionStorage.getItem('classList')),
			semesterArr:JSON.parse(sessionStorage.getItem('semesterList')) || [],
			weekDate:[],
		}
	},
	watch:{
		// 'queryParams.campus':function(n,o){
		// 	this.queryParams.grade='';
		// 	this.queryParams.class='';
		// 	this.gradeList=[];
		// 	this.classList=[];
		// 	this.gradeList=this.campusList.filter(v=>v.id===n)[0]?.children || [];
		// },
		// 'queryParams.grade':function(n,o){
		// 	this.queryParams.class='';
		// 	this.classList=[];
		// 	this.classList=this.gradeList.filter(v=>v.id===n)[0]?.children || [];
		// },
	},
	created() {
		this.campusList=this.school_info?.slice() || [];
		this.getDataList();
	},
	methods: {
		async getDataList() {
			let params = {
				orgId:sessionStorage.getItem('orgId'),
				platformCode:sessionStorage.getItem('platformCode'),
				schoolYearSemester:this.queryParams.semester,
				campusId:this.queryParams.campus,
				classId:this.queryParams.class,
				gradeId:this.queryParams.grade,
				page:this.pageNum,
				limit:this.pageSize,
			}
			// let res = await api.studentClassStatistics(params);
			// if(res.code==='0'){
			// 	this.tableData=res.data?.list || [];
			// 	this.totalPage=res.data?.total || 0;
			// }
		},
		searchFun(){
			this.pageNum=1;
			this.getDataList();
		},
		sizeChangeHandle(val) {
			this.pageSize = val
			this.getDataList()
		},
		currentChangeHandle(val) {
			this.pageNum = val
			this.getDataList()
		},
        toDetail(item){
			this.detail.info=item;
            this.detail.show=true;
        },
        toIndex(){
            this.detail.show=false;
        },
		init(){
      	let vm = this;
      	this.$nextTick(() => {
        	// 圆环图
        	let chartDom1 = document.getElementById('echarts-box1');
        	let myChart1 = echarts.init(chartDom1);
        	let option1 = {
				legend: {
					// data: [],
					// orient: 'vertical',
					left: 'center',
					top: 'bottom',
					icon : 'circle',
				},
				series: [
					{
					name: '',
					type: 'pie',
					radius: ['38%', '50%'], // 这个属性修改环形宽度
					avoidLabelOverlap: false,
					itemStyle: {
						borderRadius: 0,
						borderColor: '#fff',
						borderWidth: 0,
					},
					label: {
						show: false,
						position: 'center',
					},
					emphasis: {
						label: {
						show: false,
						fontSize: '16',
						fontWeight: 'bold',
						},
					},
					labelLine: {
						show: false,
					},
					data: [
						{ value: 60, name: '已报名学生数' },
						{ value: 158, name: '未报名学生数' },
					],
					},
				],
				// 圆环颜色
				color: ['#5BB0FF', '#51D6A6', ],
			};
        	myChart1.setOption(option1);

			// 折线图
			let chartDom2 = document.getElementById('echarts-box2');
			let myChart2 = echarts.init(chartDom2);
			let option2 = {
			tooltip: {
				trigger: 'item',
				backgroundColor: 'rgba(0, 0, 0, .6)', //通过设置rgba调节背景颜色与透明度
				borderWidth: '0',
				textStyle: {
				color: 'white',
				fontSize: '12',
				},
				formatter: function (params, ticket, callback) {
				return "<span style='font-size: 26px;line-height: 30px;'>" + params.value + '</span>' + '<br />' + "<span style='font-size:14px;line-height: 18px;'>" + params.name + '</span>';
				},
			},
			legend: {
				// data: ['Email', 'Union Ads', 'Video Ads', 'Direct', 'Search Engine'],
				left: 'center',
				top: 'bottom',
				icon : 'circle',
			},
			xAxis: {
				type: 'category',
				boundaryGap: false,
				data: this.weekDate
			},
			yAxis: {
				type: 'value'
			},
			series: [
				{
				name: '学生实际出勤数',
				type: 'line',
				stack: 'Total',
				data: [304, 332, 431, 312, 381, 356, 288],
				},
				{
				name: '学生应出勤数',
				type: 'line',
				stack: 'Total',
				data: [320, 340, 440, 315, 387, 361, 299],
				},
			],
			color: ['#5BB0FF', '#51D6A6', ],
			};
			myChart2.setOption(option2);
      	});
    	},
	},
	mounted() {
		let arr=[];
		for (let i = 1; i <= 7; i++) {
			const time = new Date(new Date().setDate(new Date().getDate() + i - 7));
			const year = time.getFullYear();
			const month = `0${time.getMonth() + 1}`.slice(-2);
			const strDate = `0${time.getDate()}`.slice(-2);
			arr.push(`${month}-${strDate}`);
		}
		this.weekDate=arr;
		// this.semesterList=this.semesterArr.map(v=>({label:v.schoolYear+'第'+v.semester+'学期',id:v.schoolYear+'_'+v.semester}))
		this.init();
	},
}
</script>
<style lang="less" scoped>
.index {
	width: 100%;
    padding: 0px 30px 30px 30px;
	.title {
		height: 60px;
		line-height: 48px;
		border-bottom: 1px solid #eaeaea;
		margin-bottom: 20px;
		display: flex;
		justify-content: flex-start;
		.span1 {
			font-family: 'PingFang SC Bold';
			font-weight: bold;
			font-size: 20px;
			text-align: left;
			color: #000;
			margin-right: 30px;
		}
	}

	::v-deep .el-form .el-input__inner {
		width: 150px;
		height: 32px;
		border-radius: 3px;
		background: #fff;
		border: 1px solid #ddd;
	}

	::v-deep .el-table__header tr th {
		background: #f7f7f7;
		box-shadow: 0px 1px 0px #eaeaea;
	}

    ::v-deep .el-date-editor .el-range-separator{
        line-height: 22px;
    }

	.pagination {
		text-align: center;
		margin-top: 30px;
	}

  header{
    width: 100%;
    height: 350px;
    display: flex;
    .header-item{
      width: 50%;
      .header-item-title{
        font-size: 18px;
        color: #333;
        display: flex;
        align-items: center;
        .circle{
          width: 8px;
          height: 8px;
          display: inline-block;
          background: #4991e1;
          border-radius: 50%;
          margin-right: 10px;
        }
      }
      .header-item-text{
        font-size: 14px;
        color: #666;
        padding-left: 20px;
        margin-top: 5px;
      }
    }
    #echarts-box1{
      width:80%;
      height:280px;
    }
	#echarts-box2{
		width: 90%;
		height:280px;
	}
  }
}
</style>
